import { FilterOptionItem } from '@src/design-system/filter-new';
import type { TRenderOptionItemCtx } from '../../types/filter-config';
import type { TLeadStatus } from '@src/shared/types/lead-status';

export function LeadStatusFilterOptionItem({
  selected,
  item,
  onToggle,
}: TRenderOptionItemCtx<TLeadStatus>) {
  return (
    <FilterOptionItem
      selected={selected}
      onClick={onToggle}
    >
      {item.name}
    </FilterOptionItem>
  );
}
